import { render, staticRenderFns } from "./PlanSettingAdd.vue?vue&type=template&id=d1cbca88&scoped=true"
import script from "./PlanSettingAdd.vue?vue&type=script&lang=js"
export * from "./PlanSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./PlanSettingAdd.vue?vue&type=style&index=0&id=d1cbca88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cbca88",
  null
  
)

export default component.exports